import _ from 'lodash'
import 'whatwg-fetch'
import ipaddr from 'ipaddr.js'
import apiURL from './api'

import SPFLookup from './spf-lookup'

import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";

import { Alert, Label, Panel, Glyphicon, Table, Col, FormGroup, FormControl, HelpBlock, Button, ProgressBar } from "react-bootstrap";

import { rrIdToName } from './DNS'

class SPFForm extends Component {

  constructor(props) {
    super(props);

    this.updateHostname = this.updateHostname.bind(this);
    this.updateData = this.updateData.bind(this);

    this.state = {
      "hostname": this.props.hostname,
    }

  }

  updateHostname(event) {
    this.setState({
      hostname: event.target.value,
    });
  }

  updateData(event) {
    event.preventDefault();
    this.props.onSubmit(this.state.hostname);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      hostname: nextProps.hostname,
    })
  }

  render() {
    return (
      <Panel>
        <Panel.Heading>SPF Lookup</Panel.Heading>
        <Panel.Body>
          <form onSubmit={this.updateData}>
            <FormGroup>
              <Col sm={11}>
                <FormControl type="text" value={this.state.hostname} onChange={this.updateHostname} />
                <HelpBlock>Check an SPF record for validity and get an approximate list of authorized IPs.</HelpBlock>
              </Col>
              <Col sm={1}>
                <Button type="submit" bsStyle="primary">Lookup</Button>
              </Col>
            </FormGroup>
          </form>
        </Panel.Body>
      </Panel>
    );
  }
}

const networkCount = function (network) {

  // Calculate the network address size from a CIDR notation

  if (network.indexOf("/") === -1) {
    return null;
  }

  let [netaddr, prefix] = ipaddr.parseCIDR(network)
  let netSize = (netaddr.kind() === "ipv4" ? 32 : 128) - prefix;

  if (netSize > 24) {
    return null;     // Too large to print
  }

  return <span>({Math.pow(2, netSize)} addresses)</span>;

}

const SPFIPList = (props) => (
  <li key={props.host}>
    <strong>{props.host}</strong>
    <ul>
    {props.networks.map((network) => <li key={network}><Link to={`/network/${network}`}>{network}</Link>{' '}<small>{networkCount(network)}</small></li>)}
    </ul>
  </li>
)

class SPFResult extends Component {

  constructor(props) {
    super(props);

    this.toggleDetails = this.toggleDetails.bind(this);

    this.state = {
      "showDetails": false,
    }

  }

  toggleDetails(event) {
    this.setState({showDetails: !this.state.showDetails})
    event.preventDefault();
  }

  render() {

    if (this.props.error !== "") {

      // Error during processing

      return (
          <Alert bsStyle="danger">{this.props.error}</Alert>
      )
    }

    if (this.props.data == null) {

      // Processing ... 

      return (
        <Panel>
          <Panel.Body>
            <div className="text-center text-muted"><Glyphicon glyph="flash" className="spinning" /> Loading SPF policy</div>
          </Panel.Body>
        </Panel>
      ) 

    }

    if (this.props.data.policy === "") {

      // No policy found

      return (
        <Alert bsStyle="warning">
          <h4>No SPF record</h4>
          <p>We could not find any SPF record on the <strong>{this.props.data.hostname}</strong> domain.</p>
        </Alert>
      );

    }

    return (
      <div>
        <SPFPolicy hostname={this.props.data.hostname} policy={this.props.data.policy} parsed={this.props.data.parsed} lookups={this.props.data.lookups} lookupCount={this.props.data.lookupCount} />
        <SPFDNSStatus showDetails={this.state.showDetails} toggleDetails={this.toggleDetails} lookups={this.props.data.lookups} lookupCount={this.props.data.lookupCount} />
        <SPFNetworks hostname={this.props.data.hostname} networks={this.props.data.networks} />
        <SPFHosts hostname={this.props.data.hostname} hosts={this.props.data.ptrHosts} />
      </div>
    )

  }

}

const SPFPolicy = (props) => {

  let ptrAlert = null;

  if (props.lookups.filter((l) => l.type === "PTR").length > 0) {

    ptrAlert = (
      <Alert bsStyle="warning">
        <h4>SPF record contains <tt>ptr</tt> mechanism</h4>
        <p>
          The SPF record of <strong>{props.hostname}</strong> contains a <tt>ptr</tt> mechanism. Use of this mechanism
          is discouraged as per <a href="https://tools.ietf.org/html/rfc4408#section-5.5">RFC 4408 section 5.5</a>.
        </p>
      </Alert>
    );

  }

  let allAlert = null;

  if (props.parsed.mechanisms.filter((m) => m.type === "all").length > 1) {
    ptrAlert = (
      <Alert bsStyle="warning">
        <h4>SPF record contains more than one <tt>all</tt> mechanism</h4>
        <p>
          This is most likely an error, because the <tt>all</tt> mechanism always matches, thus discarding any further mechanisms in the policy.
        </p>
      </Alert>
    );
  }

 let status = <Label bsStyle="success">Valid</Label>;

  if (props.lookupCount > 10) {
    status = <Label bsStyle="danger">Invalid: Too many DNS lookups</Label>;
  }

  return (
    <Panel>
      <Panel.Heading>
        SPF policy for <strong>{props.hostname}</strong>&nbsp;&nbsp;
        {status}
      </Panel.Heading>
      <Panel.Body>
        <pre style={{overflowX: "auto"}}>{props.policy}</pre>
        <Table striped bordered condensed hover>
          <thead>
            <tr>
              <th style={{width: "100px"}} className="text-center" colSpan="2">Prefix</th>
              <th className="text-center">Type</th>
              <th className="text-center">Value</th>
              <th className="text-center">Description</th>
            </tr>
          </thead>
          <tbody>
           {props.parsed.mechanisms.map((m) => <SPFMechanism mechanism={m} />)}
          </tbody>
        </Table>
        {ptrAlert}
        {allAlert}
      </Panel.Body>
    </Panel>
  );
}

const SPFMechanism = (props) => "description" in props.mechanism ? (

  <tr>
    <td style={{width: "50px"}} className="text-center"><tt>{props.mechanism.prefix}</tt></td>
    <td style={{width: "50px"}} className="text-center"><small className="text-muted">{props.mechanism.prefixdesc}</small></td>
    <td style={{width: "80px"}}><tt>{props.mechanism.type}</tt></td>
    <td>{props.mechanism.type === "include" || props.mechanism.type === "redirect" ? <Link to={`/spf/${props.mechanism.value}`}><tt>{props.mechanism.value}</tt></Link> : <tt>{props.mechanism.value}</tt>}</td>
    <td>{props.mechanism.description}</td>
  </tr>

) : null;

const SPFDNSStatus = (props) => {

  if (!props.lookups) {
    return null;
  }

  return (
    <Panel>
      <Panel.Body>
        <p>DNS requests counted towards limit: <strong>{props.lookupCount}/10</strong></p>
        <ProgressBar bsStyle="info" now={props.lookupCount*10} />
        <SPFDNSAlert lookupCount={props.lookupCount} />
        <SPFDNSDetails show={props.showDetails} lookups={props.lookups} />
        <p><Button bsSize="xsmall" onClick={props.toggleDetails}>{props.showDetails ? "Hide details" : "Show details"}</Button></p>
      </Panel.Body>
    </Panel>
  );

}
 
const SPFDNSAlert = (props) => props.lookupCount > 10 ? (
  <Alert bsStyle="danger">
    <h4>DNS lookup limit exceeded</h4>
    <p>This SPF record results in too many DNS lookups. Reduce your usage of <tt>a</tt>, <tt>mx</tt> and <tt>include</tt> mechanisms.</p>
  </Alert>
) : null;

const SPFDNSDetails = (props) => props.show ? (
  <div>
    <Table striped bordered condensed hover>
      <thead>
        <tr>
          <th style={{width: "40px", textAlign: "center"}}>Record</th>
          <th>Name</th>
          <th>Results</th>
        </tr>
      </thead>
      <tbody>
      {props.lookups.map((l) => l.type === "AAAA" ? null : (
        <tr key={`${l.name}-${l.type}`}>
          <td className="text-center"><strong className={l.count ? "text-success" : "text-muted"}><tt>{l.type}</tt></strong></td>
          <td><strong><tt>{l.name}</tt></strong></td>
          <td style={{paddingTop: "10px"}}><ul style={{paddingLeft: "30px"}}>{l.answers.map((a) => <li><SPFDNSAnswer answer={a} /></li>)}</ul></td>
          </tr>))}
        </tbody>
      </Table>
    <p className="text-right"><small>Please note: DNS query listing includes only IPv4 lookups for the <tt>a</tt>, <tt>mx</tt> mechanisms. Only <span className="text-success">GREEN</span> lookups are counted towards the limit</small></p>
  </div>
) : null;

const SPFDNSAnswer = (props) => {

  let name = rrIdToName[props.answer.type];

  if (name === "A") {
      return <tt>{name}{' '}<Link to={`/network/${props.answer.data}`}>{props.answer.data}</Link></tt>
  } 

  return <tt>{name}{' '}{props.answer.data}</tt>

}

const SPFNetworks = (props) => {

  let networkList = null;

  if (_.isEmpty(props.networks)) {

    networkList = <Alert bsStyle="info">This policy has no explicitly whitelisted IP networks</Alert>;

  } else {

    networkList = (
      <div>
        <ul>
          {Object.keys(props.networks).map((host) => <SPFIPList key={host} host={host} networks={props.networks[host]} />)}
        </ul>
      </div>
    );

  }

  return (
    <Panel>
      <Panel.Heading>Authorized networks for <strong>{props.hostname}</strong></Panel.Heading>
      <Panel.Body>
        <p>
          This is an approximate list of the IP networks that are allowed to send e-mail by published SPF policy.
        </p>
        {networkList}
      </Panel.Body>
    </Panel>
  );

}

const SPFHosts = (props) => props.hosts.length > 0 ? (
  <Panel>
    <Panel.Heading>Authorized hosts for <strong>{props.hostname}</strong></Panel.Heading>
    <Panel.Body>
      <p>Clients whose reverse DNS ends in the following domains are allowed to send e-mail by the published SPF policy:</p>
      <ul>
        {props.hosts.map((h) => <li key={h}><tt>{h}</tt></li>)}
      </ul>
    </Panel.Body>
  </Panel>
) : null;

class BaseSPFTool extends Component {
  
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateData = this.updateData.bind(this);

    this.state = {
      hostname: "hostname" in props.match.params ? props.match.params.hostname : "ubivox.com",
      error: "",
      data: null,
    };

  }

  handleHostnameChange(hostname) {
    this.setState({hostname: hostname});
  }

  componentDidMount() {
    this.updateData();
  }

  componentDidUpdate() {

    let requestedHostname = _.get(this, "props.match.params.hostname", "ubivox.com");

    if (requestedHostname === this.state.hostname) {
      return
    }

    // Reset state, this is a page change

    this.setState({
      hostname: requestedHostname,
      error: "",
      data: null,
    }, this.updateData)

  }

  handleSubmit(hostname) {

    const hostnameChanged  = _.get(this, "props.match.params.hostname", "") !== hostname;

    if (hostnameChanged) {
      this.props.history.push(`/spf/${hostname}`);
    }

    this.setState({
      hostname: hostname,
    }, this.updateData);

  }

  updateData() {

    let lookup = new SPFLookup(apiURL);

    lookup.check(this.state.hostname).then(function (data) {
      this.setState({
        error: "",
        data: data,
      })
    }.bind(this), function (error) {
      this.setState({
        error: error.toString(),
        data: null,
      })
    }.bind(this));

  }

  render() {
    return (
      <div>
        <SPFForm hostname={this.state.hostname} onSubmit={this.handleSubmit} />
        <SPFResult hostname={this.state.hostname} data={this.state.data} error={this.state.error} />
      </div>
    )
  }

}

const SPFTool = withRouter(BaseSPFTool);

export default SPFTool;



// WEBPACK FOOTER //
// ./src/SPF.js